import { Typography } from "@mui/material"
import Button from "@mui/material/Button"
import Stack from "@mui/material/Stack"
import Alert from "@mui/material/Alert"

import { useState } from "react"

import { useUserAuth } from "../../firebase/UserAuthContext"
import { useNavigate } from "react-router-dom"

const Logout = () => {
	const [error, setError] = useState("")
	const { logOut, user } = useUserAuth()
	const navigate = useNavigate()

	// useEffect(() => {
	// 	onAuthStateChanged(auth, (user) => {
	// 		if (user) {
	// 			const uid = user.uid
	// 			console.log({ uid })
	// 			setUser(user)
	// 		} else {
	// 			console.log("no user")
	// 		}
	// 	})
	// }, [])

	const handleLogout = async () => {
		try {
			await logOut()
			navigate("/")
		} catch (error) {
			console.log(error.message)
			setError(error)
		}
	}

	return (
		<div>
			{error && <Alert severity="error">{error}</Alert>}

			{user && (
				<Stack spacing={2} padding={10}>
					<Typography variant="p">
						Click "Log out" button to exit your session.
					</Typography>
					<Button variant="outlined" onClick={handleLogout}>
						Log out
					</Button>
				</Stack>
			)}
		</div>
	)
}

export default Logout
